export const EpicKeyRingLabelMap = {
    'epic-prd': 'Epic PRD',
    'epic-nonprd': 'Epic Non-PRD',
    'fhir-epic': 'FHIR Epic (shared)'
};
//# sourceMappingURL=consts.js.map